import { ReactNode } from 'react'
import Dropzone, { Accept, FileRejection } from 'react-dropzone'
import { Upload } from 'flowbite-react-icons/outline'
import { Spinner } from 'flowbite-react'

export interface FileDropzoneProps {
  children?: ReactNode
  accept?: Accept
  onChange: (acceptedFiles: File[], fileRejections: FileRejection[]) => void
  maxSize?: number
  multiple?: boolean
  color?: 'failure' | 'grayborder'
  disabled?: boolean
  loading?: boolean
}

export const FileDropzone = ({
  children,
  accept,
  onChange,
  maxSize = 10 * 1024 * 1024,
  multiple = false,
  color = 'grayborder',
  disabled = false,
  loading = false,
}: FileDropzoneProps) => {
  return (
    <Dropzone
      onDrop={onChange}
      accept={accept}
      multiple={multiple}
      maxSize={maxSize}
      disabled={disabled}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          {...getRootProps({
            className: `flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed bg-gray-50 hover:bg-gray-100 ${multiple ? 'h-80' : 'h-40'} ${isDragActive || disabled ? 'bg-gray-100 dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-700'} ${color === 'failure' ? 'border-red-500 ' : 'border-gray-300 '}`,
          })}
        >
          <div className="relative w-full h-full flex flex-col items-center justify-center">
            {loading ? <Spinner /> : <>{children}</>}
          </div>
          <input {...getInputProps()} />
        </div>
      )}
    </Dropzone>
  )
}
